import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/deal-packets/$dealId")({
  staticData: {
    breadcrumb: "Deal",
  },
  component: DealDetailLayout,
})

function DealDetailLayout() {
  return <Outlet />
}
